if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.submitButton = this.querySelector('[type="submit"]');

        this._selectors = {
          price: {
            current: '[js-price-current]',
            compare: '[js-price-compare]',
            savings: '[js-price-savings]'
          },
          upsellItem: 'product-upsells input.upsell-item-checkbox:checked'
        }

        this.price = {
          current: this.querySelector(this._selectors.price.current),
          compare: this.querySelector(this._selectors.price.compare),
          savings: this.querySelector(this._selectors.price.savings),
        }
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        document.addEventListener('upsell:change', this.handlePriceUpdate.bind(this));

        const accessoriesPanel = document.querySelector('#accessories-content-panel');
        if (accessoriesPanel) {
          accessoriesPanel.addEventListener('change', this.handlePriceUpdate.bind(this));
        }

        const bundlePanel = document.querySelector('#bundle-content-panel');
        if (bundlePanel) {
          bundlePanel.addEventListener('change', this.handlePriceUpdate.bind(this));
        }

        if (this.input) {
          this.quantityForm = this.querySelector('.product-form__quantity');
          if (!this.quantityForm) return;
          this.setQuantityBoundries();
          if (!this.dataset.originalSection) {
            this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
          }
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
            if (event.data.sectionId !== sectionId) return;
            this.updateQuantityRules(sectionId, event.data.html);
            this.setQuantityBoundries();
          });
        }

        this.handlePriceUpdate()
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => console.error(e))
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      handlePriceUpdate(event) {
        const soldierTab = document.querySelector('product-upsells s-tabs.soldier');
        if (soldierTab) {
          this.updatePricesSoldier(event);
        } else {
          this.updatePrices(event);
        }
      }

      updatePrices(event) {
        this.upsellItems = this.querySelectorAll(this._selectors.upsellItem);

        let currentPrice = Number(this.price.current.getAttribute('data-price'));
        let comparePrice = this.price.compare ? Number(this.price.compare.getAttribute('data-price')) : 0;

        for (const upsellItem of this.upsellItems) {
          const productPrice = Number(upsellItem.getAttribute('data-product-price')) ?? false
          const productSavings = Number(upsellItem.getAttribute('data-product-savings')) ?? false
          console.table({ productPrice, productSavings })
          if(productPrice) currentPrice += productPrice
          if(productSavings) comparePrice += productSavings
        }

        if (this.price.compare && comparePrice > 0 && (comparePrice !== currentPrice)) {
          this.price.compare.innerHTML = formatMoney(comparePrice, '${{no_trailing_zeros}}');
          this.price.compare.classList.remove('hidden');
        } else if (this.price.compare) {
          this.price.compare.classList.add('hidden');
        }

        if (this.price.savings) {
          const savings = comparePrice - currentPrice;

          if (savings > 0) {
            this.price.savings.innerHTML = 'Save ' + formatMoney(savings, '${{no_trailing_zeros}}');
            this.price.savings.classList.remove('hidden');
          } else {
            this.price.savings.classList.add('hidden');
          }
        }

        this.price.current.innerHTML = formatMoney(currentPrice, '${{no_trailing_zeros}}');

        // Inside updatePrices function in product-info.js, AFTER prices are calculated and innerHTML is updated:
        document.dispatchEvent(new CustomEvent('upsell:price:updated', {
            detail: {
                price: currentPrice, // The calculated price variable (ensure it's in cents)
                compareAtPrice: comparePrice // The calculated compare price variable (ensure it's in cents)
                // Add 'available' status if the upsell script determines it, otherwise we'll get it separately
            }
        }));
        console.log('Dispatched upsell:price:updated event with:', { price: currentPrice, compareAtPrice: comparePrice }); // Optional debug log
        
      }

      updatePricesSoldier(event) {
        // Retrieve base prices from data attributes
        let baseCurrentPrice = Number(this.price.current.getAttribute('data-price'));
        let baseOldPriceElement = document.querySelector('.product-pricing .old-price');
        let baseOldPrice = baseOldPriceElement ? Number(baseOldPriceElement.getAttribute('data-price')) : 0;

        // Initialize current and old prices from base values
        let currentPrice = baseCurrentPrice;
        let oldPrice = baseOldPrice;

        // Calculate price increases from accessories-content-panel
        const accessoriesCheckedItems = document.querySelectorAll('#accessories-content-panel input.upsell-item-checkbox:checked');
        let accessoriesPriceIncrease = 0;
        accessoriesCheckedItems.forEach(item => {
          accessoriesPriceIncrease += Number(item.getAttribute('data-product-price'));
        });

        // Calculate price increases from bundle-content-panel
        const bundleCheckedItems = document.querySelectorAll('#bundle-content-panel input.upsell-item-checkbox:checked');
        let bundlePriceIncrease = 0;
        bundleCheckedItems.forEach(item => {
          bundlePriceIncrease += Number(item.getAttribute('data-product-price'));
        });

        // Update current price based on bundle items
        currentPrice += bundlePriceIncrease;

        // Compute the old price taking into account the base old price and any increases
        oldPrice = baseOldPrice + accessoriesPriceIncrease + bundlePriceIncrease;

        // Display the updated prices
        this.price.current.innerHTML = formatMoney(currentPrice, '${{no_trailing_zeros}}');
        if (baseOldPriceElement) {
          baseOldPriceElement.innerHTML = formatMoney(oldPrice, '${{no_trailing_zeros}}');
        }
      }
    }
  );
}